// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"PostSearcherResults_spinnerContainer__2RkYS","noResults":"PostSearcherResults_noResults__CU6SM","error":"PostSearcherResults_error__1mMo1"};